<template>
    <div class="leaderboards">
        <!--img alt="Vue logo" src="../assets/logo.png"-->
        <LeaderboardTeams :all="true" :title="'Alle Teams'" />
    </div>
</template>

<script>
    // @ is an alias to /src
    import LeaderboardTeams from '@/components/leaderboards/LeaderboardTeams.vue';

    export default {
        name: 'TeamsList',
        components: {
            LeaderboardTeams,
        }
    }
</script>
